import {
	httpUser
} from './network'
const AUTH_STATE_KEY = "auth-state"
const AUTH_UNBIND_KEY = "auth-unbind-state"
import {
	USER_INFO,SHOW_CARE_BAR
} from '../store/mutation-types'
const { wechatId } = process.env.CONFIG
const wechatLogin = async (store, code) => {
	let ret;
	try {
		ret = await httpUser("/User/WxAuthLogin", {
			param: {
				code: code
			}
		});
		if (ret.Status === true) {
			window.local.saveValue('sessionKey', ret.Data.SessionKey)
			if (ret.Data.IsBindWeixin) {
				let userInfo = {
					avatar: ret.Data.HeadImgUrl,
					phone: ret.Data.User.LoginMobile,
					name: ret.Data.User.NickName || ret.Data.User.RealName || ret.Data.User.LoginMobile
				}
				store.dispatch(USER_INFO, userInfo)
				return {
					login: true,
					bindWechat: true
				}
			} else {
				return {
					login: true,
					bindWechat: false,
					openId: ret.Data.User.OpenId,
					unionId: ret.Data.UnionId
				}
			}
		} else {
			return {
				login: false,
				bindWechat: false
			}
		}
	} catch (e) {
		console.error("=====>", e)
	}

	return {
		login: false,
		bindWechat: false
	}
}

const unbindWechat = async (code) => {
	try {
		let ret = await httpUser("/User/WxAuthLogin", {
			param: {
				code: code
			}
		});
		if (ret.Status && ret.Data.UnionId) {
			let res = await httpUser("/User/Untying", {
				param: {
					UnionId: ret.Data.UnionId
				}
			});
			console.log(res)
		}
		window.local.remove('sessionKey')
	} catch (e) {
		console.error(e)
	}
}

const isWechatAuth = (state) => {
	return window.local.get(AUTH_STATE_KEY) === parseInt(state)
}

const isUnbind = (state) => {
	return window.local.get(AUTH_UNBIND_KEY) === parseInt(state)
}

export const wechatAuth = (unbind = false) => {
	let redirectUrl = window.location.href.replace(/&?(code|state)=[a-zA-Z0-9]+/g, '').replace(/\?$/, '');
	let state = (new Date()).getTime()
	window.local.save(AUTH_STATE_KEY, state)
	if (unbind) window.local.save(AUTH_UNBIND_KEY, state)
	let url =
		"https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
		wechatId +
		"&redirect_uri=" +
		encodeURIComponent(redirectUrl) +
		"&response_type=code&scope=snsapi_userinfo&state=" + state + "#wechat_redirect";
	window.location.href = url;
};


export const routerWechatIntercept = (store) => {
	return async (to, from, next) => {
	  
		if(to.query.ssstoken)
		{
			      console.log('ssstoken=',to.query.ssstoken);
			        store.dispatch(SHOW_CARE_BAR, false);
			 		let userinfo= await  checksessionkey(to.query.ssstoken);
			 		if(userinfo!=null)
			 		{
						console.log('ssstoken校验成功');
			 		  	store.dispatch(USER_INFO,userinfo);
			 		}
					else
					{
						console.log('ssstoken校验失败');
					}
		}
		

		if (isWechatAuth(to.query.state)) {
			let code = to.query.code
			let state = to.query.state
			let nextTo = {
				path: to.path,
				query: to.query,
				replace: true
			}
			// delete nextTo.query.state
			// delete nextTo.query.code

			if (isUnbind(state)) {
				window.local.remove(AUTH_STATE_KEY)
				unbindWechat(code)
				next(nextTo)
				return true
			}
			window.local.remove(AUTH_STATE_KEY)
			let ret
			try{
				ret =	await wechatLogin(store, code)
			}catch(e){
				console.error(e)
			}
			if (ret&&ret.login && ret.bindWechat) {
				next(nextTo)
			} else if (ret&&ret.login && !ret.bindWechat) {
				next({
					path: '/auth',
					query: {
						type: 'bindWechat',
						redirect: JSON.stringify(nextTo),
						openId: ret.openId,
						unionId: ret.unionId
					}
				})
			} else {
				next({
					path:"/login-fail"
				})
			}
			return true
		}
		return false
	}
}

export const login = (store, router,gotopath) => {
	if (store.state.isWechat) {
		wechatAuth()
	} else if (store.state.isApp) {
		window.$mobile.login((res) => {
			window.local.saveValue("sessionKey", res.SessionKey);
			let userInfo = {
				avatar: res.HeadImgUrl,
				phone: res.User.LoginMobile,
				name:
					res.User.NickName ||
					res.User.RealName ||
					res.User.LoginMobile
			};
			store.dispatch(USER_INFO, userInfo);
		})
	} else {
		let { path, query } = router.history.current;
		if(gotopath)
		{
			router.push({
				path: "/auth",
				query: {
					redirect: JSON.stringify({
						path: gotopath,
						query: query
					})
				}
			});
		}
		else
		{
			router.push({
				path: "/auth",
				query: {
					redirect: JSON.stringify({
						path: path,
						query: query
					})
				}
			});
		}
		
	}
}

export const checksessionkey = async (sessionkey) => {
	let rest = await httpUser("/User/CheckSessionKey", {
		param: {
			sessionKey: sessionkey,
		},
		type:'post'
	});
	if (rest.Status){
		   //console.log(rest);
		   let res=rest.Data;
			window.local.saveValue("sessionKey", res.SessionKey);
			let userInfo = {
				avatar: res.HeadImgUrl,
				phone: res.User.LoginMobile,
				name:
					res.User.NickName ||
					res.User.RealName ||
					res.User.LoginMobile
			};
			 return userInfo;
	}
	return null;
	
};


export const unbind = () => {
	wechatAuth(true)
}